// Tono semántico → clase CSS del dashboard. El módulo compartido de
// etiquetas (`@bitacorapro/api-types` → observation-labels.ts) sólo
// exporta TONOS; cada cliente decide cómo se pintan. Acá:
//   - estado y modificadores van en `.st-pill--*`;
//   - criticidad va en `.sev-pill--s1..s4` (cuatro colores propios,
//     decisión del fundador; `sev-peak` es el escalón S1).

import type { PillTone } from "@bitacorapro/api-types";

export const ST_PILL_CLASS: Record<PillTone, string> = {
  neutral: "st-pill--idle",
  info: "st-pill--info",
  ok: "st-pill--ok",
  "sev-low": "st-pill--low",
  "sev-med": "st-pill--warn",
  "sev-high": "st-pill--crit",
  // El dashboard no tiene un st-pill más alto que crit: un estado nunca
  // usa este tono, pero el mapa es total.
  "sev-peak": "st-pill--crit",
  danger: "st-pill--danger",
};

export const SEV_PILL_CLASS: Record<PillTone, string> = {
  "sev-peak": "sev-pill--s1",
  "sev-high": "sev-pill--s2",
  "sev-med": "sev-pill--s3",
  neutral: "sev-pill--s4",
  // Tonos que la criticidad no usa hoy; caen al escalón más cercano.
  "sev-low": "sev-pill--s4",
  info: "sev-pill--s4",
  ok: "sev-pill--s4",
  danger: "sev-pill--s1",
};
